@import '../../themes/capsule.globals';

:host {
  --container-box-shadow: none;
  --container-box-shadow-color: var(--cpsl-color-file-border-placeholder);
  --container-border-color: var(--cpsl-color-file-border-placeholder);
  --container-border-color-error: var(--cpsl-color-file-border-error);
  --container-background-color: var(--cpsl-color-file-surface-default);
  --container-background-color-disabled: var(--cpsl-color-file-surface-disabled);
  --container-background-color-drag: var(--cpsl-color-file-surface-drag);
  --container-border-width: 1px;
  --container-border-radius: var(--cpsl-border-radius-file);
  --container-padding-top: 12px;
  --container-padding-bottom: 12px;
  --container-padding-end: 12px;
  --container-padding-start: 12px;
  --container-height: 48px;
  --container-gap: 8px;

  --optional-label-color: var(--cpsl-color-text-secondary);
  --label-color: var(--cpsl-color-text-primary);
  --label-font-size: var(--cpsl-font-size-body-s);
  --label-margin-bottom: 0px;

  --helper-text-color: var(--cpsl-color-text-secondary);
  --helper-text-error-color: var(--cpsl-color-text-error);
  --helper-text-icon-color: var(--cpsl-color-text-secondary);
  --helper-text-icon-error-color: var(--cpsl-color-text-error);
  --helper-text-icon-size: 16px;
  --helper-text-font-size: var(--cpsl-font-size-body-xs);
  --helper-text-margin-top: 0px;

  --sample-img-height: 40px;
  --sample-img-width: 40px;
  --sample-img-border-radius: 8px;

  display: flex;
  flex-direction: column;
  gap: 4px;

  font-family: $font-family-base;
}

.container {
  @include padding(var(--container-padding-top), var(--container-padding-end), var(--container-padding-bottom), var(--container-padding-start));

  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-wrap: wrap;
  width: 100%;
  gap: var(--container-gap);
  cursor: pointer;
  position: relative;

  border-style: solid;
  border-width: var(--container-border-width);
  border-color: var(--container-border-color);
  border-radius: var(--container-border-radius);
  background: var(--container-background-color);

  box-shadow: var(--container-box-shadow);

  &.drag,
  &:active {
    background: var(--container-background-color-drag);
  }

  &.drag-error {
    cursor: no-drop;
  }

  &.error {
    border-color: var(--container-border-color-error);
  }
}

input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0px;
  opacity: 0;
  cursor: pointer;
}

.sample-img {
  height: var(--sample-img-height);
  width: var(--sample-img-width);
  border-radius: var(--sample-img-border-radius);
  object-fit: contain;
}

.sample-image-name-container {
  display: flex;
  gap: 4px;
  align-items: center;
  text-align: center;

  cpsl-icon {
    z-index: 10000;
    --height: 16px;
    --width: 16px;
  }
}

.inline-text {
  display: inline-block;
}

.sample-image-name {
  display: inline-block;
  color: var(--cpsl-color-text-tertiary);
}

.label-container {
  flex: 1;
}

.file-container {
  display: flex;
  flex-direction: column;
  flex: 0;
  min-width: 33%;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.label {
  display: inline-block;
  color: var(--label-color);
  font-size: var(--label-font-size);
  font-weight: 500;

  margin-bottom: var(--label-margin-bottom);
}

.optional-label {
  display: inline-block;
  color: var(--optional-label-color);
  // TODO: this will use a typography size once typography changes
  font-size: var(--label-font-size);
  font-weight: 500;
}

.helper-text-container {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--helper-text-color);
  font-size: var(--helper-text-font-size);
  font-weight: 500;

  margin-top: var(--helper-text-margin-top);

  cpsl-icon {
    --height: var(--helper-text-icon-size);
    --width: var(--helper-text-icon-size);
    --icon-color: var(--helper-text-icon-color);
  }
}

.error-text {
  color: var(--helper-text-error-color);

  cpsl-icon {
    --icon-color: var(--helper-text-icon-error-color);
  }
}
